@use "sass:map";
@import '../../styles/variables.scss';

.projectSelection {
    position: relative;
    overflow: visible;
    width: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.bottom{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    align-items: center;
    padding: 6px 0 7px 0;
    height: 19px;
}

.version {
    font-size: 11px;
}

.sendFeedback {
    display: none;
}

.group {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 0 12px 0;
    border-top: 1px solid map.get($colors-basic, "divider");
    border-bottom: 1px solid map.get($colors-basic, "divider");
}

.iconGroup {
    display: flex;
    flex-direction: row;
    overflow: hidden;
}

.actionGroup {
    margin: auto 6px;
}

.icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 12px;

    img.logo {
        width: 32px;
        height: 32px;
    }
}

.titleGroup {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.heading {
    font-size: map.get($font-sizes, "caption");
    color: map.get($colors-basic, "textGray");
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}